import { StringSchema, addMethod } from 'yup';

declare module 'yup' {
  interface StringSchema {
    minLowercase(length: number, message: string): StringSchema;
    minLowercase(length: number): StringSchema;
    minLowercase(): StringSchema;
    minUppercase(length: number, message: string): StringSchema;
    minUppercase(length: number): StringSchema;
    minUppercase(): StringSchema;
    minNumbers(length: number, message: string): StringSchema;
    minNumbers(length: number): StringSchema;
    minNumbers(): StringSchema;
    password(message: string): StringSchema;
    password(): StringSchema;
  }
}

const isNullOrUndefined = function (value?: string) {
  return value === null || value === undefined;
};

export const setup = (yup: { string: () => StringSchema; addMethod: typeof addMethod }) => {
  yup.addMethod<StringSchema>(yup.string, 'minLowercase', function minLowercase(length = 2, message) {
    const msg = message || '${path} must contain at least ${length} lowercase letter';

    return this.test({
      name: 'minLowercase',
      exclusive: true,
      message: msg,
      params: { length },
      test(value) {
        return isNullOrUndefined(value) || (value?.match(/[a-z]/g) || []).length >= length;
      },
    });
  });

  yup.addMethod<StringSchema>(yup.string, 'minUppercase', function minUppercase(length = 2, message) {
    const msg = message || '${path} must contain at least ${length} uppercase letter';

    return this.test({
      name: 'minUppercase',
      exclusive: true,
      message: msg,
      params: { length },
      test(value) {
        return isNullOrUndefined(value) || (value?.match(/[A-Z]/g) || []).length >= length;
      },
    });
  });

  yup.addMethod<StringSchema>(yup.string, 'minNumbers', function minNumbers(length = 2, message) {
    const msg = message || '${path} must contain at least ${length} number';

    return this.test({
      name: 'minNumbers',
      exclusive: true,
      message: msg,
      params: { length },
      test(value) {
        return isNullOrUndefined(value) || (value?.match(/[0-9]/g) || []).length >= length;
      },
    });
  });

  yup.addMethod<StringSchema>(yup.string, 'password', function password(message: string) {
    const msg = message || '${path} not satisfy the policy';

    return this.min(8, msg).max(250, msg).minLowercase(1, msg).minUppercase(1, msg).minNumbers(1, msg);
  });
};
